import { render, staticRenderFns } from "./CustomerAssessmentTerms.vue?vue&type=template&id=21826300&scoped=true&"
import script from "./CustomerAssessmentTerms.vue?vue&type=script&lang=js&"
export * from "./CustomerAssessmentTerms.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAssessmentTerms.vue?vue&type=style&index=0&id=21826300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21826300",
  null
  
)

export default component.exports